import { css } from '@emotion/css';

export const applyFilterBtn = (params) => css`
  margin-right: 14px;
  ${params?.resetAlign === 'start' && params?.buttonAligned === 'end' && (
    `
      order: 2;
      margin-right: 0;
    `
  )}
`;
